import React from 'react';
import TreeList from 'devextreme-react/tree-list';
import { BCTreeListProps, BCTreeListRef } from '../entities';
import { TreeListRef } from 'devextreme-react/tree-list';

export const BCTreeList = React.forwardRef<BCTreeListRef, BCTreeListProps>((props, ref) => {
	const treeListRef = React.useRef<TreeListRef>();

	React.useImperativeHandle(ref, () => treeListRef.current);

	React.useEffect(() => {
		treeListRef.current?.instance().on('optionChanged', e => console.log(e));

		return () => {
			treeListRef.current?.instance().off('optionChanged');
		};
	}, [treeListRef]);

	return (
		<TreeList
			ref={treeListRef}
			{...props}
		/>
	);
});
